"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceivedOcpiTrackingIdValidation = void 0;
class ReceivedOcpiTrackingIdValidation {
    static isValid(entity) {
        // Validate entity.port_id for existence and correct type.
        if (entity.port_id == undefined)
            return false;
        if (typeof entity.port_id !== "number")
            return false;
        // Validate entity.tracking_id for existence and correct type.
        if (entity.tracking_id == undefined)
            return false;
        if (typeof entity.tracking_id !== "string")
            return false;
        return true;
    }
}
exports.ReceivedOcpiTrackingIdValidation = ReceivedOcpiTrackingIdValidation;
